require("org/roster_upload/sso_roster_review.scss");

class SSORosterReview extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var selectedRosterIDs = []
		var selectedStudentIDs = []

		this.state = {
			stage: CLASS_SELECTION,
			selectedRosterIDs, selectedStudentIDs, selectAll: true
		};

		this.continueButton = React.createRef();
		this.selectionWrap = React.createRef();
		 LuckyOrangeClient.tagComponent("SSORosterReview");
	}

	isGoogle(props) {
		return (props || this.props).method == GOOGLE_SYNC;
	}
	isClever(props) {
		return (props || this.props).method == CLEVER_SYNC;		
	}

	ssoSectionKey(props) {
		if (this.isGoogle(props)) {
			return "google_id";
		} else if (this.isClever(props)) {
			return "clever_id";
		}
	}
	ssoStudentKey(props) {
		if (this.isGoogle(props)) {
			return "google_sign_in_id";
		} else if (this.isClever(props)) {
			return "clever_sign_in_id";
		}
	}

	toggleSection(sectionID) {
		if (this.isGoogle(this.props)) {
			var section = _.findWhere(this.props.rosterData, { 'google_id': sectionID })
		} else {
			var section = _.findWhere(this.props.rosterData, { 'clever_id': sectionID })
		}

		if (section) {
			var students = section['students']
			var studentIDs = _.pluck(students, this.ssoStudentKey(this.props))

			if (this.state.selectedRosterIDs.includes(sectionID)) {
				var selectedRosterIDs = _.without(this.state.selectedRosterIDs, sectionID);
				var selectedStudentIDs = _.filter(this.state.selectedStudentIDs, (id) => { return !_.include(studentIDs, id) })
			} else {
				var selectedRosterIDs = this.state.selectedRosterIDs.concat(sectionID);
				var selectedStudentIDs = this.state.selectedStudentIDs.concat(studentIDs)
			}
			this.setState({ selectedRosterIDs, selectedStudentIDs });
		}
	}

	toggleStudent(sectionID) {
		if (this.state.selectedStudentIDs.includes(sectionID)) {
			var selectedStudentIDs = _.without(this.state.selectedStudentIDs, sectionID);
		} else {
			var selectedStudentIDs = this.state.selectedStudentIDs.concat(sectionID);
		}
		this.setState({ selectedStudentIDs });
	}

	changeStage(stage, e) {
		$wr.nope(e);
		this.setState({ stage }, this.updateButtonPosition);
	}

	completeSync() {
		var finalData = [];
		_.each(this.props.rosterData, (roster) => {
			if (this.state.selectedRosterIDs.includes(roster[this.ssoSectionKey()])) {
				var finalRoster = _.clone(roster);
				finalRoster.students = _.select((roster.students || []), (student) => {
					return this.state.selectedStudentIDs.includes(student[this.ssoStudentKey()]);
				})

				finalData.push(finalRoster);
			}
		});
		this.props.finalizeRoster(finalData);
	}

	renderClassSelection() {
		if (this.isGoogle()) {
			var header = "Select the classes you want to import into your Roster. Make sure there aren't duplicate classes.";
		} else if (this.isClever()) {
			var header = "Which classes do you want to sync?";
		}

		var sortedSections = _.sortBy(this.props.rosterData, "name");

		var classOptions = _.map(sortedSections, (section) => {
			var selected = this.state.selectedRosterIDs.includes(section[this.ssoSectionKey()]);
			return (
				<label key={ section[this.ssoSectionKey()] } className="normal selectionOp">
					<span className="double">
						<input type="checkbox" checked={ selected } className="selectionCheckbox"
							onChange={ this.toggleSection.bind(this, section[this.ssoSectionKey()]) } />
					</span>
					<span className="selectionLabel">
						{ section.name }
					</span>
					<span className="subLine">
						{ $wr.pluralizeWithNumber("student", (section.students || []).length) }
					</span>
				</label>
			);
		});

		if (this.state.selectedRosterIDs.length > 0) {
			var nextButton = (
				<button className="continueButton btn buttonPrimary"
					ref={ this.continueButton }
					onClick={ this.changeStage.bind(this, STUDENT_SELECTION) }>
					Next
				</button>
			);
		}

		return (
			<div>
				<p>{ header }</p>
				<div className="selectionWrap" ref={ this.selectionWrap }>
					<div className="selectionOptions">
						{ classOptions }
					</div>
					<div className="nextSection">
						{ nextButton }
					</div>
				</div>
			</div>
		)
	}

	selectAllStudents() {
		var selectedSections = _.sortBy(_.select(this.props.rosterData, (section) => {
			return this.state.selectedRosterIDs.includes(section[this.ssoSectionKey()]);
		}), "name");

		_.map(selectedSections, (section) => {
			var sortedStudents = _.sortBy((section.students || []), (student) => {
				return student.last_name + ", " + student.first_name;
			})
			var sectionIDS = []
			_.map(sortedStudents, (student) => {
				var sectionID = student[this.ssoStudentKey()]
				sectionIDS.push(sectionID)
			});
			if (_.intersection(sectionIDS).length == this.state.selectedStudentIDs.length) {
				var selectedStudentIDs = [];
				var selectAll = false;
			} else {
				var selectedStudentIDs = this.state.selectedStudentIDs.concat(sectionIDS);
				var selectAll = true;
			}
			this.setState({ selectedStudentIDs: selectedStudentIDs, selectAll: selectAll });
		})
	}


	renderStudentSelection() {
		if (this.isGoogle() || this.isClever()) {
			var header = "Select the students you want to import into your Roster";
		}

		var selectedSections = _.sortBy(_.select(this.props.rosterData, (section) => {
			return this.state.selectedRosterIDs.includes(section[this.ssoSectionKey()]);
		}), "name");

		var classSections = _.map(selectedSections, (section) => {
			var selected = this.state.selectedStudentIDs.includes(section[this.ssoSectionKey()]);

			var sortedStudents = _.sortBy((section.students || []), (student) => {
				return student.last_name + ", " + student.first_name;
			})

			var studentOptions = _.map(sortedStudents, (student) => {
				var selected = this.state.selectedStudentIDs.includes(student[this.ssoStudentKey()]);
				return (
					<p key={ student[this.ssoStudentKey()] } className="normal selectionOp">
						<span className="double">
							<input type="checkbox" checked={ selected } className="selectionCheckbox"
								onChange={ this.toggleStudent.bind(this, student[this.ssoStudentKey()]) } />
						</span>

						<span className="selectionLabel student">
							{ student.first_name } { student.last_name }
						</span>
					</p>
				);
			});

			if (this.state.selectAll) {
				var control = (<a className="control" onClick={ this.selectAllStudents }>Clear All</a>)
			} else {
				var control = (<a className="control" onClick={ this.selectAllStudents }>Select All</a>)
			}

			return (
				<div key={ section[this.ssoSectionKey()] } className="classSection">
					<p className="sectionName">
						{ section.name }
						{ control }
					</p>
					<div className='studentOptions'>
						{studentOptions}
					</div>
				</div>
			);
		});

		if (this.state.selectedStudentIDs.length > 0) {
			var completeButton = (
				<button className="continueButton btn buttonSuccess"
					ref={ this.continueButton }
					onClick={ this.completeSync }>
					Complete Sync
				</button>
			);
			var className = "finalStep";
		}

		var studentCount = this.props.studentCount;
		if (studentCount > 0) {
			if (this.isClever()) {
				var loginInfo = (
					<div className="loginMethod clever">
						<p className="notice">{ studentCount } students are being added to your <i>Roster</i> with your Clever account. </p>
						<div>
							<img className="stepsImg" src={  require("misc/student-login-clever.gif") } alt="Log into Whooo's Reading with Clever" />
							<div className="infoContainer">
								<p className="header">How students log in from Whooo's Reading:</p>
								<ol>
									<li>Go to www.whooosreading.org</li>
									<li>Click <b>Log In</b> button (upper right)</li>
									<li>Select <b>Student</b></li>
									<li>Click <b>Sign in with Clever</b></li>
									<li>Enter Clever login information</li>
								</ol>
							</div>
						</div>
						<div>
							<img className="stepsImg" src={  require("misc/clever.gif") } alt="clever-share-settings" />
							<div className="infoContainer">
								<p className="header">How students log in from Clever:</p>
								<ol>
									<span>Teacher</span><br/> 
									<li>Go to Clever home page</li>
									<li>Click <b>Add</b> button (bottom right)</li>
									<li>Select <b>App</b></li>
									<span className="studentSteps">Students</span><br/> 
									<li>Log into Clever</li>
									<li>Select Whooo's Reading icon shown on their accounts.</li>
								</ol>
							</div>
						</div>
					</div>
				)
			} else if (this.isGoogle()){
				var loginInfo = (
					<div className="loginMethod">
						<p className="notice">{ studentCount } students are being added to your <i>Roster</i> from your Google Classroom account. </p>
						<div>
							<img className="stepsImg" src={  require("misc/student-login-google.gif") } alt="Log into Whooo's Reading with Google Classroom" />
							<div className="infoContainer">
								<p className="header">How students log into Whooo's Reading:</p>
								<ol>
									<li>Go to www.whooosreading.org</li>
									<li>Click <b>Log In</b> button (upper right)</li>
									<li>Select <b>Student</b></li>
									<li>Click <b>Sign in with Google</b></li>
									<li>Enter Google account login information</li>
								</ol>
								<p>
									If you are unsure how to do this, help your students with <a href="https://whooosreading.zendesk.com/hc/en-us/articles/115001477811" target="_blank">these login instructions</a>.
								</p>
							</div>
						</div>
					</div>
				)
			}
			var content = loginInfo
		} else {
			var content = (
				<div>
					<p className="stageHeader">
						{ header }<br />
						<a href="#" className="backLink"
							onClick={ this.changeStage.bind(this, CLASS_SELECTION) }>
							{ "< " } Back
						</a>
					</p>
					<div className="selectionWrap" ref={ this.selectionWrap }>
						<div className="selectionOptions">
							{ classSections }
						</div>
						<div className={ className + " nextSection" }>
							{ completeButton }
						</div>
					</div>
				</div>
			)
		}

		return content 
	}

	render() {
		if (this.state.stage == CLASS_SELECTION) {
			var stageContent = this.renderClassSelection();
		} else if (this.state.stage == STUDENT_SELECTION) {
			var stageContent = this.renderStudentSelection();			
		}
		return(
			<div className="ssoRosterReview">
				{ stageContent }
			</div>
		)
	}

	componentDidMount() {
		$(document).on("modal-scroll", this.updateButtonPosition);
		this.updateButtonPosition();
	}
	componentWillUnmount() {
		$(document).off("modal-scroll", this.updateButtonPosition);
	}

	updateButtonPosition() {
		var $btn = $(this.continueButton.current);
		var $wrap = $(this.selectionWrap.current);

		var windowHeight = $(window).height();
		var wrapY = $wrap.offset().top;
		var wrapHeight = $wrap.height();
		var buttonHeight = $btn.outerHeight();
		var give = 15;

		var baseOffset = Math.max(Math.min(wrapHeight, windowHeight - wrapY), 0);
		var offset = baseOffset - (buttonHeight + give);

		$btn.css({ top: offset });
	}
};

var CLASS_SELECTION = "class-selection";
var STUDENT_SELECTION = "student-selection";

var GOOGLE_SYNC = "google-sync";
SSORosterReview.GOOGLE_SYNC = GOOGLE_SYNC;

var CLEVER_SYNC = "clever-sync";
SSORosterReview.CLEVER_SYNC = CLEVER_SYNC;

SSORosterReview.propTypes = StrictPropTypes({
	rosterData: PropTypes.array.isRequired,
	finalizeRoster: PropTypes.func.isRequired,
	method: PropTypes.string.isRequired,
	studentCount: PropTypes.number
});

module.exports = SSORosterReview;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/SSORosterReview.js